import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } });
        setUser(r.data);
        // clean fragment
        window.history.replaceState(null, "", window.location.pathname);
        if (r.data?.is_admin) {
          navigate("/admin", { replace: true, state: { user: r.data } });
        } else {
          navigate("/", { replace: true, state: { user: r.data } });
        }
      } catch (e) {
        navigate("/login?error=1", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto" />
        <div className="mt-4 text-sm text-slate-600 font-medium">Signing you in…</div>
      </div>
    </div>
  );
}
